import type { TaskBrandResource } from '@/features/tasks/api/taskBrandResource'
import type { ActionTaskPlatform } from '@/features/tasks/types/actionTaskDetail'

import { TASK_CARD_BRAND_LOGO } from '../TaskCard/taskCard.constants'

export const TASK_CARD_COVER_PLACEHOLDER =
  '/assets/tasks/tasks-card/taskCard1.webp'

export function resolveTaskCoverSrc(
  coverUrl: string | null | undefined
): string {
  if (typeof coverUrl === 'string' && coverUrl.trim().length > 0) {
    return coverUrl.trim()
  }
  return TASK_CARD_COVER_PLACEHOLDER
}

export function resolveTaskBrandLogoSrc(
  url: string | null | undefined
): string {
  if (typeof url === 'string' && url.trim().length > 0) {
    return url.trim()
  }
  return TASK_CARD_BRAND_LOGO
}

export const TASK_CARD_DEMO_COVERS = [
  '/assets/tasks/tasks-card/taskCard1.webp',
  '/assets/tasks/tasks-card/taskCard2.webp',
  '/assets/tasks/tasks-card/taskCard3.webp',
  '/assets/tasks/tasks-card/taskCard4.webp'
] as const

export type TaskCardDemoSocial =
  | 'tiktok'
  | 'instagram'
  | 'youtube'
  | 'x'
  | 'facebook'
  | null

export type TaskCardDemoTitle =
  | 'watch'
  | 'share'
  | 'shareShort'
  | 'action'
  | 'create'

export type TaskCardDemoRow = {
  id: string
  rewardPoints: number
  hoursLeft: number
  coverI: 0 | 1 | 2 | 3
  coverUrl?: string | null
  participantCurrent: number
  participantLimit: number
  popularityScore?: number
  social: TaskCardDemoSocial
  cta: 'watch' | 'share' | 'action' | 'create'
  reserved: boolean
  title: TaskCardDemoTitle
  apiTitle?: string
  apiDescription?: string
  apiBrandName?: string
  apiBrandLogoUrl?: string
  apiBrandResources?: TaskBrandResource[]
  watchVideoUrl?: string
  taskProgressId?: string
  fromClosedTaskList?: boolean
  closedWatchRewardClaimed?: boolean
  watchProgressState?: 'in_progress' | 'success' | 'failed'
  watchFailureReason?: string
  isRetry?: boolean
  failureReason?: string
  actionPlatforms?: ActionTaskPlatform[]
  /** Every platform of a group card when it shows more than one. */
  socials?: NonNullable<TaskCardDemoSocial>[]
  /** A task group card: statuses live on the task page, not on the card. */
  groupCard?: boolean
}
